import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "10px",
	height: "14px",
	viewBox: "0 0 10 14",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Combined Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Design",
			stroke: "none",
			strokeWidth: 1,
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Overview",
				transform: "translate(-925.000000, -1756.000000)",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-Copy-12",
					transform: "translate(902.000000, 1736.000000)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M30.0006983,24.9994275 L28.7904497,26.2094096 C28.3792852,26.1866694 27.9605448,26.3323485 27.6464466,26.6464466 L25.5251263,28.767767 C24.9393398,29.3535534 24.9393398,30.3033009 25.5251263,30.8890873 L26.232233,31.5961941 C26.8180195,32.1819805 27.767767,32.1819805 28.3535534,31.5961941 L30.4748737,29.4748737 C30.7886406,29.1611069 30.9343434,28.7429185 30.9119822,28.3321719 L32.1223452,27.1215693 C32.6545358,28.2365441 32.4589321,29.6121357 31.5355339,30.5355339 L29.4142136,32.6568542 C28.2426407,33.8284271 26.3431458,33.8284271 25.1715729,32.6568542 L24.4644661,31.9497475 C23.2928932,30.7781746 23.2928932,28.8786797 24.4644661,27.7071068 L26.5857864,25.5857864 C27.5094461,24.6621268 28.8855554,24.4666738 30.0006983,24.9994275 Z M30.8284271,21.3431458 L31.5355339,22.0502525 C32.7071068,23.2218254 32.7071068,25.1213203 31.5355339,26.2928932 L29.4142136,28.4142136 C28.5443427,29.2840844 27.2731842,29.5080925 26.1966352,29.0862378 L27.5040285,27.7780474 C27.8148357,27.734104 28.1145008,27.5926059 28.3535534,27.3535534 L30.4748737,25.232233 C31.0606602,24.6464466 31.0606602,23.6966991 30.4748737,23.1109127 L29.767767,22.4038059 C29.1819805,21.8180195 28.232233,21.8180195 27.6464466,22.4038059 L25.5251263,24.5251263 C25.1476263,24.9026262 25.0133997,25.4312769 25.1224464,25.9162653 L23.974442,27.0641084 C23.3257495,25.9197497 23.4890909,24.4398413 24.4644661,23.4644661 L26.5857864,21.3431458 C27.7573593,20.1715729 29.6568542,20.1715729 30.8284271,21.3431458 Z",
						id: "Combined-Shape"
					})
				})
			})
		})
	]
});
export default SvgLink;
